function P1EReferralTermVO(key, code, title, oidRoot, oidExtension, cito, issuerName, issuerSurname, nfzAvailable) {

    this.key = key;
    this.code = code;
    this.title = title;
    this.oidRoot = oidRoot;
    this.oidExtension = oidExtension;
    this.cito = cito;
    this.issuerName = issuerName;
    this.issuerSurname = issuerSurname;
    this.nfzAvailable = nfzAvailable;

    var _typeContext = {
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
